export default __webpack_public_path__ + "static/media/brown_sofa.37570f96.png";